<template>
  <div class="relative item">
    <Loading v-if="loading" />

    <v-sheet v-else color="#cccccc">
      <v-img
        :src="
          files +
          (xs && item.img_banner_inside_mobile
            ? item.img_banner_inside_mobile
            : item.img_banner_inside_desktop)
        "
        min-height="400px"
        :aspect-ratio="xs ? 600 / 600 : 1920 / 680"
        class="d-flex align-center justify-center pointer-none"
      >
        <v-container v-if="!hiddenLogo" class="pa-0">
          <v-row justify="center" no-gutters>
            <v-col cols="8" sm="7" md="6" lg="5">
              <img
                :src="files + informations.img_brand"
                :alt="informations.title"
                class="d-block mx-auto item-brand"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-img>
    </v-sheet>
  </div>
</template>

<script>
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-banners",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    hiddenLogo: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: true,
    informations: {},
    item: {},
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest("pages-informations").get({
      id: this.mod,
      save: (state, data) => (this.informations = data),
    });

    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
  },
};
</script>

<style lang="scss" scoped>
.pointer-none {
  pointer-events: none;
}
.item {
  .item-brand {
    height: 100%;
    max-height: 257px;
    max-width: 100%;
    object-fit: contain;
    -o-object-fit: contain;
    @media screen and (max-width: 960px) {
      max-height: 120px;
    }
  }
}
</style>
